<template>
  <div>
    <!-- table principal -->
    <rabbey-toolbox>
      <div class="mr-5 box">
        <el-select
          v-model="serviceTypeID"
          @change="handlerChangesServices"
          size="mini"
          clearable
          placeholder="Tipo de servicio"
          class="ml-5"
          filterable
        >
          <el-option
            v-for="item in serviceTypeList"
            :key="item.Id"
            :label="item.Description"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <yearcomponent
          ref="yearC"
          @change="handler_year"
          v-model="year"
        ></yearcomponent>
      </div>
      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="employeeId"
          filterable
          clearable
          size="mini"
          placeholder="Colaborador"
          @change="handleChangeEmployee"
        >
          <el-option
            v-for="item in employees"
            :key="item.EmployeeID"
            :label="item.Name"
            :value="item.EmployeeID"
          >
          </el-option>
        </el-select>
      </div>

      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="deparmentId"
          filterable
          clearable
          size="mini"
          placeholder="Departamento"
          @change="handleChangeDeparment"
        >
          <el-option
            v-for="(item, index) in deparments"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="directionIdFilter"
          filterable
          clearable
          size="mini"
          placeholder="Direccion"
          @change="handleChangeDirection"
        >
          <el-option
            v-for="(item, index) in directions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </rabbey-toolbox>

    <el-row>
      <el-col>
        <!-- <rabbey-table2
          :columns="columns2"
          :show-summary="true"
          :summary-method="getTotalByMonthSLA"
          :default-items="technicalTracker"
          :paginateFromApi="false"
          v-loading="principalTable"
        /> -->
        <rabbey-table-3
          v-loading="principalTable"
          :columns="columns2"
          :data="technicalTracker"
        />
      </el-col>
    </el-row>

    <!-- table detalle por Vendedor -->
    <DetailSatisfaccionKpiGerencial ref="details" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import { MonthsRabbey3, commentColumns } from "@/helpers/SatisfaccionColumns";
import { getTotalByMonthSLA } from "@/helpers/TableRabbeyTools";
import DetailSatisfaccionKpiGerencial from "./DetailSatifaccionKpiGerencial.vue";
import { formatArrayToElSelect } from "@/utils";

export default {
  name: "KpiSatisfaccion",
  // components: { yearcomponent },
  components: { DetailSatisfaccionKpiGerencial, yearcomponent },
  data() {
    return {
      //Filtros
      deparmentId: "",
      employeeId: "",
      serviceTypeID: "",
      directionIdFilter: "",

      directionId: 0,
      serviceTypeList: [],
      loading: false,
      deparments: [],
      directions: [],
      employees: [],
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",

      typeServices: [],
      Valor: [
        { value: 0, label: "Todas las Solicitudes" },
        { value: 1, label: "Calificadas" }
      ],
      types: [
        { value: 0, label: "Todos" },
        { value: 2, label: "MagyTrack" },
        { value: 14, label: "TPD" },
        { value: 15, label: "NCF Movil" },
        { value: 16, label: "SeaHorse" },
        { value: 17, label: "MagyPago" },
        { value: 18, label: "Magylottery" }
      ],
      SellerName: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      product: 0,
      valoracionTypeID: 0,
      InvoiceNum: "",
      ContactEmail: "",
      ProductList: [],
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      columns: [
        {
          prop: "tecnico",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        }
        //...Months
      ],
      columns2: [
        {
          prop: "technical",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        },
        ...this.mapOb(MonthsRabbey3)
      ],
      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false,
      StarTracker: {
        Compliment: 1
      },
      technicalTracker: []
    };
  },
  mounted() {
    this.$refs.yearC.Year = this.year;
  },
  created() {
    this.getEmployees();
    this.getDepartaments();
    this.getDirections();
    this.getData();
    this.$store.dispatch("request_types/internal");
    this.$store.dispatch("products/all");

    this.$http
      .get("/api/KpiTechnicalSupport/getTypeServicesSLA", {
        params: { companyId: this.currentCompany }
      })
      .then(({ data }) => {
        this.typeServices = this.formatArrayToElSelect(data, {
          value: "Id",
          label: "Description"
        });
        this.typeServices.unshift({ value: 0, label: "Todos los Servicios" });
      });
  },
  watch: {
    list_products() {
      this.list_products.unshift({ value: 0, label: "Todos los Productos" });
    },
    list_types_to_select() {
      this.list_types_to_select.unshift({
        value: 0,
        label: "Todos los Servicios"
      });
    }
  },
  computed: {
    ...mapGetters({
      list_types_to_select: "request_types/list_to_select",
      list_products: "products/list_products"
    }),
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    groupItems() {
      return this._.groupBy(this.items, "tecnico");
    }
  },
  methods: {
    getTotalByMonthSLA,
    formatArrayToElSelect,
    getPorcentajeByUserAndMonth(month, techinicalName, year) {
      const KpiTechnicalSupport = this.groupItems[techinicalName];
      if (KpiTechnicalSupport === undefined) {
        return 0;
      }
      let countStar = 0;
      for (let index = 0; index < KpiTechnicalSupport.length; index++) {
        const element = KpiTechnicalSupport[index];
        const fecha = this.$moment(element.fecha, "YYYY-MM-DDTHH:mm:ss.SSS");
        const elementMonth = fecha.format("M");
        const elementYear = fecha.format("YYYY");
        if (month === elementMonth && year === elementYear) {
          countStar++;
        }
      }
      const suma = countStar;
      let Promedio = suma > 0 ? countStar / suma : 0;
      let Porcentaje = Promedio > 0 ? (Promedio / 5) * 100 : 0;

      return Porcentaje;
    },
    openDetail(mes, row) {
      this.$refs.details.show(row, mes, this.year, false);
    },
    getProductSelected() {
      return this.product;
    },
    getValoracionSelected() {
      return this.valoracionTypeID;
    },
    getServiceTypeSelected() {
      return this.serviceTypeID;
    },
    mapOb(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getProductSelected: this.getProductSelected,
          getServiceTypeSelected: this.getServiceTypeSelected,
          getValoracionSelected: this.getValoracionSelected,
          openDetail: this.openDetail,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },

    handlerChangesProduct(_Product) {
      this.product = _Product;
      this.getData();
    },

    handlerChanges(_valoracion) {
      this.valoracionTypeID = _valoracion;
      this.getData();
    },
    handlerChangesServices(_Service) {
      this.serviceTypeID = _Service;
      this.getData();
    },
    handleChangeDirection(directionId) {
      this.directionIdFilter = directionId;
      this.directionId = directionId;
      this.getDepartaments();
      this.getData();
      this.getServicesTypes(this.directionId);
    },
    handleChangeDeparment(deparmentId) {
      this.deparmentId = deparmentId;
      this.getEmployees();
      this.getData();
    },
    handleChangeEmployee(employee) {
      this.employeeId = employee;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },
    getData() {
      let params = {
        year: this.year,
        companyID: this.currentCompany,
        product: this.product,
        serviceTypeID: this.serviceTypeID,
        valoracionTypeID: this.valoracionTypeID,
        directionId: this.directionId ? this.directionId : 0,
        employeeId: this.employeeId ? this.employeeId : 0,
        deparmentId: this.deparmentId ? this.deparmentId : 0
      };

      this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/KpiTechnicalSupport/GetKpiSatisfaccionInternal", {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.$store.commit("rabbey_table/items", data);

          // Agrupar solicitudes por vendedor
          const technicalsGroup = this._.groupBy(data, "tecnico");
          // Lista de nombres de tecnicos
          const technicals = Object.keys(technicalsGroup);
          // Cantidad de estrellas
          const limitOfStars = 5;

          let t = {};
          this.technicalTracker = [];

          // Iterar entre cada tecnico
          for (let index = 0; index < technicals.length; index++) {
            // Obtener el nombre del tecnico actual
            const techinicalName = technicals[index];

            // Inicializar objeto del tecnico
            t = {
              technicalId: 0,
              technical: techinicalName,
              gerencia: false,
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
              total: 0
            };

            // Obtener las solicitudes del tecnico actual
            const solicitudes = technicalsGroup[techinicalName];
            // Obtener la primera solicitud
            const primeraSolicitud = solicitudes[0];
            // Obtener la fecha de la solicitud y formatear con moment
            const fecha = this.$moment(
              primeraSolicitud.fecha,
              "YYYY-MM-DDTHH:mm:ss.SS"
            );
            // Obtener el year de la solicitud
            const year = parseInt(fecha.format("YYYY"));

            // Asignar tecnico id
            t.technicalId = primeraSolicitud.AssignedTechnicianId;
            // t.valoracion = primeraSolicitud.valoracion;

            // Objeto acumulador de valores
            let monthTracker = {
              1: {
                valoracion: 0,
                count: 0
              },
              2: {
                valoracion: 0,
                count: 0
              },
              3: {
                valoracion: 0,
                count: 0
              },
              4: {
                valoracion: 0,
                count: 0
              },
              5: {
                valoracion: 0,
                count: 0
              },
              6: {
                valoracion: 0,
                count: 0
              },
              7: {
                valoracion: 0,
                count: 0
              },
              8: {
                valoracion: 0,
                count: 0
              },
              9: {
                valoracion: 0,
                count: 0
              },
              10: {
                valoracion: 0,
                count: 0
              },
              11: {
                valoracion: 0,
                count: 0
              },
              12: {
                valoracion: 0,
                count: 0
              }
            };

            // Iterar entre las solicitudes del tecnico actual, y sumar sus valores por mes y year
            for (let index = 0; index < solicitudes.length; index++) {
              // Obtener solicitud
              const solicitud = solicitudes[index];
              // Obtener fecha
              const fecha = this.$moment(
                solicitud.fecha,
                "YYYY-MM-DDTHH:mm:ss.SS"
              );
              // Obtener mes de la solicitud
              const elementMonth = parseInt(fecha.format("M"));
              // Obtener year de la solicitud
              const elementYear = parseInt(fecha.format("YYYY"));

              // Bucle similuador de mes, para sumar los valores del mismo mes y year
              for (let month = 1; month < 13; month++) {
                if (month === elementMonth && year === elementYear) {
                  monthTracker[month].valoracion += solicitud.valoracion;
                  monthTracker[month].count++;
                }
              }
            }

            // Calcular porcentaje por mes
            let sumAssessment = 0;
            let countRequest = 0;
            for (let month = 1; month < 13; month++) {
              const { valoracion, count } = monthTracker[month];
              sumAssessment += valoracion;
              countRequest += count;

              const sumValores = valoracion / count;

              t[`${month}`] =
                sumValores > 0 ? (sumValores / limitOfStars) * 100 : 0;
            }

            // Calcular el total de la linea
            const sumTotal = sumAssessment / countRequest;
            t.total = sumTotal > 0 ? (sumTotal / limitOfStars) * 100 : 0;

            // Agregar tecnico
            this.technicalTracker.push(t);
          }
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    },
    TotalMes: function () {
      if (this.technicalTracker.length <= 0) {
        return 0;
      }

      return this.technicalTracker
        .filter((item) => item.valoracion > 0)
        .map((item) => item.valoracion)
        .reduce((a, c) => a + c);
    },
    getDirections() {
      this.$http
        .get("/api/Directions/DirectionsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.directions = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    getDepartaments() {
      this.directionId = this.directionId == "" ? 0 : this.directionId;
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;
      uri = `/api/Directions/DepartmentByDirecctionIDExt?DirecctionId=${this.directionId}&CompanySelected=${company}&employeeid=${employeeId}`;
      this.$http
        .get(uri)
        .then((response) => {
          this.deparments = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getServicesTypes(criteria) {
      criteria = criteria == "" ? 0 : criteria;
      this.$http
        .get("/api/serviceRequestTypes/GetServiceByCompany", {
          params: {
            direccionID: criteria != undefined ? criteria : 0
          }
        })
        .then((resp) => {
          this.serviceTypeList = resp.data.filter(
            (f) => f.IsInternal !== null && f.IsInternal
          );
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
